import mutations from './mutations';
var state = () => ({
  orderFormId: null
});
export default {
  namespaced: true,
  state,
  mutations
};